export enum SignInSteps {
  // 공통
  email = 'email',

  // 로그인
  signinPassword = 'signin-password',

  // 비밀번호 재설정
  resetPasswordverifyPhone = 'reset-password-verify',
  resetPassword = 'reset-password',
  resetPasswordCompleted = 'reset-password-completed',

  // 회원가입
  signupPassword = 'signup-password',
  verifyPhone = 'verify-phone',
  extraInfo = 'extra-info', // 추가정보
  userPurpose = 'user-purpose', // 추가정보-사용목적
  agreement = 'agreement',
}

export enum SignInActionType {
  signin = 'signin',
  signup = 'signup',
  resetPassword = 'resetPassword',
}
